import React from "react";
import { BiCopy } from "react-icons/bi";
import { toast } from "react-toastify";

// interface Props extends FlexProps {
//   text: string;
//   message?: string;
//   onCopy?: () => void;
//   component?: React.ReactNode;
// }

const Copyable = ({
  text = "",
  message,
  onCopy,
  component,
  children,
  ...rest
}) => {
  const _onClick = (evt) => {
    evt.stopPropagation();
    navigator.clipboard?.writeText(text);
    // handleSuccessMessage(message || "Copied");
    onCopy && onCopy();
    toast(`Copied to clipboard.`)
  };

  return (
    <div
      style={{
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        gap: "10px",
        position:"relative",
        paddingRight:"10px"
      }}
      onClick={_onClick}
      {...rest}
    >
      {!component && !children && text}
      {component || children || (
        <BiCopy color="#000" style={{ fontSize: "1.2rem" }} />
      )}
    </div>
  );
};

export default Copyable;
